const normalizeOrderItemType = (type) => {
  const value = String(type || 'case').toLowerCase()

  return {
    value,
    label: value.charAt(0).toUpperCase() + value.slice(1),
  }
}

export const buildReorderCart = (orderItems = [], products = []) => {
  const productsById = new Map(
    products.map((product) => [Number(product.raw.id), product]),
  )
  const cart = {}
  let unavailableItemCount = 0

  orderItems.forEach((orderItem) => {
    const productId = Number(orderItem.data['product-id'])
    const product = productsById.get(productId)

    if (!product || (product.data.bin && String(product.data.bin).toUpperCase() !== 'AVAILABLE')) {
      unavailableItemCount += 1
      return
    }

    cart[productId] = {
      ...product.data,
      id: productId,
      qty: orderItem.data.qty,
      type: normalizeOrderItemType(orderItem.data.type),
    }
  })

  return { cart, unavailableItemCount }
}
